import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Country } from '../models/lookup-data.model';



export function CountryValidator(countries: Country[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean} | null => {

        const selectedCountryCode = control.value;
        const selectedCountries = countries.filter(c => c.Code === selectedCountryCode);

        if (selectedCountries && selectedCountries.length === 1) {

          const selectedCountry = selectedCountries[0];

           if (selectedCountry.Status === 'Blocked') {
               return { 'blockedCountry': true};
           } else if (selectedCountry.Status === 'Regular') {
            return { 'regularCountry': true};
           }

        } else {
            return { 'duplicateCountryCodes': true};
        }
        return null;
    };
}

export function AgentCountryValidator(countries: Country[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean} | null => {

        const selectedCountryCode = control.value;
        const selectedCountries = countries.filter(c => c.Code === selectedCountryCode);

        if (selectedCountries && selectedCountries.length === 1) {

          const selectedCountry = selectedCountries[0];

           if (selectedCountry.Status === 'Blocked') {
               return { 'blockedCountry': true};
           }

        } else {
            return { 'duplicateCountryCodes': true};
        }
        return null;
    };
}
